import { SVGIconComponent } from './types';

export const ProjectTypeCommercial: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="project-type/commercial" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M8.92943182,0 L3,0 L3,18 L7.32033889,18 L7.31959702,12.5454433 L10.6796611,12.5454433 L10.6796611,18 L15,18 L14.9992581,0 L8.92943182,0 Z M8.51087777,10.6367925 L5.15081368,10.6367925 L5.15081368,7.3639475 L8.51087777,7.3639475 L8.51087777,10.6367925 Z M8.51087777,5.45455667 L5.15081368,5.45455667 L5.15081368,2.18171167 L8.51087777,2.18171167 L8.51087777,5.45455667 Z M12.875603,10.6367925 L9.5155389,10.6367925 L9.5155389,7.3639475 L12.875603,7.3639475 L12.875603,10.6367925 Z M12.875603,5.45455667 L9.5155389,5.45455667 L9.51628077,2.18171167 L12.8763449,2.18171167 L12.875603,5.45455667 Z"
        id="Shape"
        fill="#848484"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
